// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookshelf-page {
  padding: 0 24px;
  padding-bottom: 56px;
}

.books-grid {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  padding: 0.5rem;
}

.category-section h2 {
  font-family: "Crimson", serif;
  text-align: center;
  line-height: 1.1;
  font-size: 38px;
  font-weight: 700;
  margin: 0;
  margin-bottom: 32px;
  padding-top: 48px;
  font-size: 32px;
  letter-spacing: 1px;
  line-height: 1;
  text-transform: uppercase;
}

.book {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;
  transform-style: preserve-3d;
  max-width: 300px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid rgba(135, 134, 127, 0.25);
  border-radius: 16px;
  padding: 32px 24px;
}

.book-cover-wrapper {
  position: relative;
  overflow: visible;
}

.book-cover-wrapper img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: calc(10px + 0.75rem);
  width: 160px;
}

.book h3 {
  font-family: "Crimson", serif;
  text-align: center;
  line-height: 1.1;
  font-size: 24px;
  margin: 0;
  margin-bottom: 0.75rem;
}

.book h5 {
  font-size: 18px;
  font-family: 'Crimson', serif;
  font-style: italic;
  margin: 0;
  margin-bottom: 20px;
  padding-bottom: 20px;
  width: 100% !important;
  text-align: center;
  border-bottom: 1px solid rgba(135, 134, 127, 0.25);
}

.book-author {
  font-size: 14px;
}

.book-tags {
  display: flex;
  gap: 0.5rem;
  margin-top: 8px;
}

/* Unified tag styling for tier, coming soon, and genre tags */
.tag {
  background-color: #e0e0e0;
  font-family: 'Crimson', serif;
  border-radius: 12px;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

/* Removed previous styling for .book-tier, .book-genre, .book-tier-tier-1, and .book-tier-coming-soon */

/* Non-clickable state */
.non-clickable {
  cursor: default;
  opacity: 0.6;
}

/* Enhanced page flip animation */
@keyframes pageFlip {
  0% {
    transform: rotateY(0deg);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  50% {
    transform: rotateY(-15deg) translateZ(20px);
    box-shadow: -10px 4px 15px rgba(0, 0, 0, 0.15);
  }
  100% {
    transform: rotateY(0deg);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
}

@media (max-width: 992px) {
  .book {
    padding: 24px 16px;
  }

  .book-cover-wrapper img {
    width: 120px;
  }

  .book h3 {
    font-size: 20px;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .bookshelf-container {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 1.5rem;
  }

  .book-cover {
    width: 140px;
    height: 210px;
  }

  .book-title {
    font-size: 1.1rem;
  }

  .category-section h2 {
    font-size: 1.6rem;
  }

  .book-author {
    font-size: 0.8rem;
  }

  .books-grid {
    flex-direction: column;
    align-items: center;
  }
}

/* Custom scrollbar styling */
.bookshelf-container::-webkit-scrollbar {
  width: 8px;
}

.bookshelf-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.bookshelf-container::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 4px;
}

.bookshelf-container::-webkit-scrollbar-thumb:hover {
  background: #9CA3AF;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/bookshelf/Bookshelf.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,wGAAwG;;AAExG,wBAAwB;AACxB;EACE,eAAe;EACf,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE;IACE,wBAAwB;IACxB,wCAAwC;EAC1C;EACA;IACE,2CAA2C;IAC3C,8CAA8C;EAChD;EACA;IACE,wBAAwB;IACxB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,4DAA4D;IAC5D,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA,6BAA6B;AAC7B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".bookshelf-page {\n  padding: 0 24px;\n  padding-bottom: 56px;\n}\n\n.books-grid {\n  display: flex;\n  justify-content: center;\n  gap: 1.5rem;\n  padding: 0.5rem;\n}\n\n.category-section h2 {\n  font-family: \"Crimson\", serif;\n  text-align: center;\n  line-height: 1.1;\n  font-size: 38px;\n  font-weight: 700;\n  margin: 0;\n  margin-bottom: 32px;\n  padding-top: 48px;\n  font-size: 32px;\n  letter-spacing: 1px;\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.book {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  background-color: #ffffff;\n  cursor: pointer;\n  position: relative;\n  transform-style: preserve-3d;\n  max-width: 300px;\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid rgba(135, 134, 127, 0.25);\n  border-radius: 16px;\n  padding: 32px 24px;\n}\n\n.book-cover-wrapper {\n  position: relative;\n  overflow: visible;\n}\n\n.book-cover-wrapper img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin-bottom: calc(10px + 0.75rem);\n  width: 160px;\n}\n\n.book h3 {\n  font-family: \"Crimson\", serif;\n  text-align: center;\n  line-height: 1.1;\n  font-size: 24px;\n  margin: 0;\n  margin-bottom: 0.75rem;\n}\n\n.book h5 {\n  font-size: 18px;\n  font-family: 'Crimson', serif;\n  font-style: italic;\n  margin: 0;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  width: 100% !important;\n  text-align: center;\n  border-bottom: 1px solid rgba(135, 134, 127, 0.25);\n}\n\n.book-author {\n  font-size: 14px;\n}\n\n.book-tags {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 8px;\n}\n\n/* Unified tag styling for tier, coming soon, and genre tags */\n.tag {\n  background-color: #e0e0e0;\n  font-family: 'Crimson', serif;\n  border-radius: 12px;\n  padding: 4px 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n/* Removed previous styling for .book-tier, .book-genre, .book-tier-tier-1, and .book-tier-coming-soon */\n\n/* Non-clickable state */\n.non-clickable {\n  cursor: default;\n  opacity: 0.6;\n}\n\n/* Enhanced page flip animation */\n@keyframes pageFlip {\n  0% {\n    transform: rotateY(0deg);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  50% {\n    transform: rotateY(-15deg) translateZ(20px);\n    box-shadow: -10px 4px 15px rgba(0, 0, 0, 0.15);\n  }\n  100% {\n    transform: rotateY(0deg);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n}\n\n@media (max-width: 992px) {\n  .book {\n    padding: 24px 16px;\n  }\n\n  .book-cover-wrapper img {\n    width: 120px;\n  }\n\n  .book h3 {\n    font-size: 20px;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .bookshelf-container {\n    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n    gap: 1.5rem;\n  }\n\n  .book-cover {\n    width: 140px;\n    height: 210px;\n  }\n\n  .book-title {\n    font-size: 1.1rem;\n  }\n\n  .category-section h2 {\n    font-size: 1.6rem;\n  }\n\n  .book-author {\n    font-size: 0.8rem;\n  }\n\n  .books-grid {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n/* Custom scrollbar styling */\n.bookshelf-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.bookshelf-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.bookshelf-container::-webkit-scrollbar-thumb {\n  background: #D1D5DB;\n  border-radius: 4px;\n}\n\n.bookshelf-container::-webkit-scrollbar-thumb:hover {\n  background: #9CA3AF;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
